import React from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  Typography,
} from "@material-ui/core";

const GroupDownloadDialog = ({ open, onClose }) => {
  const job = useSelector((state) => state.groupDownloadJob);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Group Download</DialogTitle>
      <DialogContent>
        {job.status === "processing" && (
          <>
            <Typography variant="body2">Total Invoices : {job.totalInvoices}</Typography>
            <Typography variant="body2">Completed Invoices : {job.completedInvoices}</Typography>
            <Typography variant="body2">Remaining Invoices : {job.remainingInvoices}</Typography>
            <Typography variant="body2">Total ZIP Files : {job.totalBundles}</Typography>
            <Typography variant="body2">ZIP Files Downloaded : {job.downloadedBundles.length}</Typography>
            <Typography variant="body2">
              Current ZIP : {job.currentBundle} / {job.totalBundles}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 8 }}>
              Status: {job.currentStatusMessage || "Processing..."}
            </Typography>
            <Typography variant="body2">Progress: {job.progressPercentage}%</Typography>
            <LinearProgress
              variant="determinate"
              value={job.progressPercentage}
              style={{ margin: "12px 0" }}
            />
            <Typography variant="caption" color="textSecondary" display="block">
              You can continue working while your download is being prepared. Each ZIP
              downloads automatically as soon as it's ready.
            </Typography>
          </>
        )}

        {job.status === "completed" && (
          <>
            <Typography gutterBottom>✅ Group Download Complete</Typography>
            <Typography variant="body2">
              {job.downloadedBundles.length} of {job.totalBundles} ZIP file(s) downloaded.
            </Typography>
          </>
        )}

        {job.status === "failed" && (
          <Typography color="error">{job.message || "Group Download failed."}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupDownloadDialog;
